// @flow

import type { Alternative, Poll, Vote } from '../../../types'

export function createVote (clientId: number, poll: Poll, alternative: Alternative): Vote {
  return {
    clientId,
    pollId: poll.id,
    alternativeId: alternative.id
  }
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/helpers/createVote.js